module.exports = __webpack_public_path__ + "img/img_02.b91eae19.png";